export default "__VITE_ASSET__BJaqyXpr__"